"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.create = exports.updateMaps = exports.getIds = exports.getAll = exports.get = void 0;
var lodash_1 = __importDefault(require("lodash"));
var firebase = __importStar(require("../firebase/fbase"));
var UpdateContainer_1 = require("../utils/UpdateContainer");
var COLLECTION_NAME = 'DEPARTMENT';
var get = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebase.dbService.collection(COLLECTION_NAME).doc(id).get()];
            case 1: return [2 /*return*/, (_a.sent()).data()];
        }
    });
}); };
exports.get = get;
var getAll = function () { return __awaiter(void 0, void 0, void 0, function () {
    var collectionData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebase.dbService.collection(COLLECTION_NAME).get()];
            case 1:
                collectionData = _a.sent();
                return [2 /*return*/, lodash_1.default.map(collectionData.docs, function (docData) { return docData.data(); })];
        }
    });
}); };
exports.getAll = getAll;
var getIds = function () { return __awaiter(void 0, void 0, void 0, function () {
    var collectionData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebase.dbService.collection(COLLECTION_NAME).get()];
            case 1:
                collectionData = _a.sent();
                return [2 /*return*/, lodash_1.default.map(collectionData.docs, function (docData) { return docData.id; })];
        }
    });
}); };
exports.getIds = getIds;
var updateMap = function (departmentId, updateObject) { return __awaiter(void 0, void 0, void 0, function () {
    var finalUpdateObject, departmentObject;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                finalUpdateObject = {};
                if (lodash_1.default.isEmpty(departmentId)) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, (0, exports.get)(departmentId)];
            case 1:
                departmentObject = _a.sent();
                lodash_1.default.forEach(['controlIds', 'staffIds'], function (targetKey) {
                    var newIds = (0, UpdateContainer_1.applyUpdateIds)(departmentObject[targetKey], updateObject === null || updateObject === void 0 ? void 0 : updateObject[targetKey]);
                    lodash_1.default.set(finalUpdateObject, targetKey, newIds);
                });
                return [4 /*yield*/, firebase.dbService.collection(COLLECTION_NAME).doc(departmentId).update(finalUpdateObject)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var updateMaps = function (departmentObject) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(lodash_1.default.map(departmentObject.values(), function (department, departmentId) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, updateMap(departmentId, department)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.updateMaps = updateMaps;
var create = function (departmentId) { return __awaiter(void 0, void 0, void 0, function () {
    var departmentDataAll, duplicateCheckForDepartmentId, newDepartment, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.getIds)()];
            case 1:
                departmentDataAll = _a.sent();
                duplicateCheckForDepartmentId = lodash_1.default.find(departmentDataAll, { id: departmentId });
                if (!lodash_1.default.isUndefined(duplicateCheckForDepartmentId)) {
                    return [2 /*return*/, Promise.reject(new Error("".concat(departmentId, " \uB294 \uC774\uBBF8 \uC874\uC7AC\uD558\uB294 \uBD80\uC11C\uC785\uB2C8\uB2E4.")))];
                }
                newDepartment = {
                    id: departmentId,
                    name: departmentId,
                    staffIds: [],
                    controlIds: []
                };
                docRef = firebase.dbService.collection(COLLECTION_NAME).doc(departmentId);
                return [4 /*yield*/, docRef.set(newDepartment)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.create = create;
var remove = function (departmentId) { return __awaiter(void 0, void 0, void 0, function () {
    var departmentData, staffIds, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.get)(departmentId)];
            case 1:
                departmentData = _a.sent();
                if (lodash_1.default.isEmpty(departmentData)) {
                    return [2 /*return*/];
                }
                staffIds = departmentData.staffIds;
                if (staffIds.length > 0) {
                    return [2 /*return*/, Promise.reject(new Error("".concat(departmentId, " \uC5D0 \uC18C\uC18D\uB41C \uC9C1\uC6D0\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uBA3C\uC800 \uB2E4\uB978 \uBD80\uC11C\uB85C \uC62E\uACA8\uC8FC\uC138\uC694")))];
                }
                docRef = firebase.dbService.collection(COLLECTION_NAME).doc(departmentId);
                return [4 /*yield*/, docRef.delete()];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.remove = remove;
//# sourceMappingURL=DepartmentManager.js.map